import { render, staticRenderFns } from "./JobItem.vue?vue&type=template&id=bdd8e238"
import script from "./JobItem.vue?vue&type=script&lang=ts"
export * from "./JobItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports